import React from 'react'

const WandIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      {...props}
    >
      <g fill="#0085FF" clipPath="url(#WandIcon)">
        <path d="M13.662 7.07c.137 0 .244-.097.273-.244.43-2.197.723-2.676 2.999-3.008.156-.02.253-.136.253-.273a.28.28 0 0 0-.253-.293c-2.276-.332-2.666-.86-2.999-2.988C13.906.098 13.8 0 13.662 0c-.156 0-.264.098-.293.254-.43 2.178-.723 2.666-2.988 2.998a.281.281 0 0 0-.264.293c0 .137.098.244.264.273 2.265.332 2.646.81 2.988 2.998.02.157.117.254.293.254ZM2.773 15.078c.147 0 .245-.098.264-.234.293-1.836.293-1.973 2.285-2.285.137-.02.235-.108.235-.254 0-.147-.098-.235-.235-.254-1.992-.313-1.992-.45-2.285-2.285-.02-.137-.117-.235-.264-.235-.136 0-.234.098-.253.235-.293 1.836-.293 1.972-2.286 2.285-.136.02-.234.107-.234.254 0 .146.098.234.234.254 1.993.312 1.993.449 2.286 2.285.02.136.117.234.253.234Zm3.262 2.754c.117 0 .195-.088.225-.205.176-1.084.127-1.133 1.367-1.357.117-.03.195-.118.195-.225a.23.23 0 0 0-.195-.225c-1.23-.224-1.172-.254-1.367-1.367-.03-.107-.117-.195-.225-.195-.117 0-.195.088-.224.215-.235 1.093-.137 1.152-1.358 1.347-.127.02-.205.108-.205.225 0 .107.078.195.195.224 1.23.225 1.133.274 1.368 1.358.029.117.107.205.224.205ZM17.285 18.925c.43.44 1.142.43 1.552 0 .42-.44.42-1.103-.01-1.553L6.347 4.892c-.43-.44-1.143-.44-1.553 0-.42.44-.42 1.104.01 1.543l12.48 12.49ZM8.827 9.404l-3.359-3.37a.33.33 0 0 1 0-.478.339.339 0 0 1 .479 0l3.369 3.38-.489.468Z" />
      </g>
      <defs>
        <clipPath id="WandIcon">
          <path fill="#fff" d="M0 0h20.645v20.635H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WandIcon
